// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__EIUix","left":"InfoRow_left__eP-7Q"};